import { withProps } from 'recompose';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { TABS_ORDER } from './constants';

export default withProps(({ leaderboards }) => {
    const t = usePortletTranslations();
    return {
        tabs: TABS_ORDER
            .map(status => ({
                title: t(`tabs.title.${status.toLowerCase()}`),
                count: leaderboards[status] && leaderboards[status].length,
                name: status
            }))
            .filter(({ count }) => Boolean(count))
    };
});
